// v2/services/ventaPresencial.service.js
//
// Cliente API para el sub-flujo de pago Webpay QR de venta presencial.
// El resto del flujo presencial (crear venta, asignar inscrito, cotizar)
// sigue en v1 hasta Sprint 6+.

import { v2Post, v2Get } from './client.js';

const BASE = '/v2/venta-presencial';

const VentaPresencialV2 = {
  /**
   * POST /v2/venta-presencial/pago-webpay/iniciar
   * @param {object} payload
   * @param {string} payload.ventaPresencialId
   * @param {string} payload.returnUrl - URL a la que Webpay redirige tras pago
   * @returns {Promise<{token, url, codigoVenta, monto, ventaPresencialId}>}
   *   El frontend renderiza `url` como código QR para que el cliente escanee.
   */
  iniciarPagoWebpay: async ({ ventaPresencialId, returnUrl }) => {
    const r = await v2Post(`${BASE}/pago-webpay/iniciar`, { ventaPresencialId, returnUrl });
    return r.data || r;
  },

  /**
   * GET /v2/venta-presencial/pago-webpay/return?token_ws=...
   * @returns {Promise<{estado, codigoVenta, ventaPresencialId, inscripcionIds, motivo?}>}
   */
  confirmarPagoWebpay: async (tokenWs) => {
    const r = await v2Get(`${BASE}/pago-webpay/return`, { params: { token_ws: tokenWs } });
    return r.data || r;
  }
};

export default VentaPresencialV2;
